export const currentLocale = () => 'nl-NL'

const countryCodeFromLocale = (locale, defaultLocale = 'NL') =>
  locale.split('-')[1] || defaultLocale
export const currentCountryCode = () => countryCodeFromLocale(currentLocale())
